import { Routes } from '@angular/router';
import { PageBuilderComponent } from './page-builder/page-builder.component';
import { NewSchoolComponent } from './new-school/new-school.component';

export const routes: Routes = [
    { path: "new", component: NewSchoolComponent },
    { path: ":firstPath", component: PageBuilderComponent },
    { path: ":firstPath/:secondPath", component: PageBuilderComponent },
    { path: ":firstPath/:secondPath/:thirdPath", component: PageBuilderComponent },
    { path: ":firstPath/:secondPath/:thirdPath/forthPath", component: PageBuilderComponent },
    { path: "**", component: PageBuilderComponent }
];
